import { Component, OnInit } from '@angular/core';
import { M2MDataStore } from './m2m-data-store';
import { RoutingInfoService } from '@routing';
import { M2MDeviceStateTranslationService } from './m2m-device-state-translation.service';
import { M2MInformationItemNameTranslationService } from './m2m-information-item-name-translation.service';
import { Router } from '@angular/router';

@Component({
    templateUrl: './m2m-router-detail.template.html',
    standalone: false
})
export class M2MRouterDetailComponent implements OnInit {
    public deviceId: string;
    public details: any;

    constructor(
        private router: Router,
        private routingInfo: RoutingInfoService,
        private m2mDataStore: M2MDataStore,
        public m2MDeviceStateTranslationService: M2MDeviceStateTranslationService,
        public m2MInformationItemNameTranslationService: M2MInformationItemNameTranslationService) {
        const routingParams = this.routingInfo.getCurrentRoutingParams();
        this.deviceId = routingParams.deviceid;
    }

    public ngOnInit(): void {
        this.m2mDataStore.getDeviceDetails(this.deviceId)
            .then((data) => this.details = data)
            .catch((reason) => {
                if (reason === 404) {
                    this.router.navigateByUrl('/Administration/M2MRouter');
                }
            });
    }
}
